import axios from 'axios';
import { QuotationResponseType } from '../enums';
import { SaveQuoteRequest, SaveQuoteResponse } from 'type';
import { SAVE_QUOTE } from './constants';

/**
 * Function to save quote to shortlist
 */
export const saveQuote = (placeOrderRequest: SaveQuoteRequest) => {
  return new Promise((resolve, reject) => {
    axios
      .post<number, SaveQuoteResponse>(SAVE_QUOTE(), placeOrderRequest)
      .then((result) => {
        result.data.modalTypeId = QuotationResponseType.Success;
        resolve(result);
      })
      .catch(() => {
        reject(QuotationResponseType.UnknownError);
      });
  });
};
